import * as React from 'react';
import { createElement } from 'react';
import { Button, Notification } from '@alifd/next';
import request from '@/utils/request';
const Save = (props) => {
    const [loading, setLoading] = React.useState(false);
    const { formId, getFormValues, processType, opinionFormInstance, displayName } = props;
    const getComment = () => {
        return opinionFormInstance.getValues();
    };
    const getForm = () => {
        return getFormValues();
    };
    const save = async () => {
        setLoading(true);
        await request
            .post('/api/process/field/mapper/info', {
            formId,
            procCfgType: processType,
            formData: JSON.stringify(getForm()),
            comment: getComment(),
        })
            .then(() => {
            Notification.success({
                title: '保存成功',
            });
        })
            .finally(() => {
            setLoading(false);
        });
    };
    return (createElement(Button, { onClick: save, loading: loading }, displayName));
};
export default Save;
